import { combineReducers } from "redux";
import ChatBotReducer from "./features/ChatBotReducer.js";
import config from "./features/ConfigReducer.js";
import "file-saver";
import "lodash";
import "moment-timezone";
const combineAppReducer = (reducers) => {
  return combineReducers({
    ...reducers,
    config,
    chatBot: ChatBotReducer
  });
};
export {
  combineAppReducer
};
//# sourceMappingURL=Reducer.js.map
